<template>
  <div class="fill-question-wrapper">
    <base-question :is-detail="isDetail" :index="index" :question-data="questionData">
    <div class="fill-question-content">
      <div v-for="(item, key) in questionData.memberAnswerList" :key="key" :class="['fill-question', {'is-detail': isDetail}]">
        <upload-type
          v-if="item.optionType === 3"
          :is-detail="isDetail"
          :value="item"
          :risk-pic="riskPic"
          @input="(val) => changeData(val, key)"
          @uploading="(val) => uploading(val, item)" />
        <fill-type
          v-else
          :is-detail="isDetail"
          :value="item"
          @input="val => item = val" />
      </div>
    </div>
    </base-question>
  </div>
</template>

<script>
import BaseQuestion from './base.vue'
import FillType from '../types/fillType.vue'
import UploadType from '../types/uploadType.vue'

export default {
  name: 'FillQuestion',
  props: {
    questionData: {
      type: Object,
      default: ()=>{}
    },
    value: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    riskPic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseQuestion,
    FillType,
    UploadType
  },
  data() {
    return {
    };
  },
  methods: {
    changeData(val, key) {
      this.$set(this.questionData.memberAnswerList, [key], val);
    },
    uploading(val, item) {
      this.$emit('uploading', val);
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-question-wrapper {
  margin-top: 12px;
  .fill-question-content {
    margin-top: 32px;
  }
  .fill-question {
    margin-bottom: 32px;
    &.is-detail {
      margin-bottom: 24px;
    }
    &:last-child {
      margin-bottom: unset;
    }
  }
}
</style>
